module.exports = __webpack_public_path__ + "assets/pdf.270a652f.svg";